import { Box, Heading, Icon } from '@chakra-ui/react';

import SectionContainer from '~/containers/SectionContainer';
import PageContainer from '~/containers/PageContainer';
import Content from '~/containers/Content';

import BackwardBar from '~/components/BackwardBar';

import { HostContent, MemberContent } from './components';

import { useNavigate, useParams } from 'react-router-dom';

import isHostSelector from '~/recoil/selectors/isHost';
import { useRecoilValue } from 'recoil';

import * as fp from 'lodash/fp';

import { IoPeopleOutline } from 'react-icons/io5';

export default function GroupBuyCreate() {
  const navigate = useNavigate();
  const { groupId = '' } = useParams();
  const isHost = useRecoilValue(isHostSelector);

  return (
    <PageContainer hideHeader hideNavBar>
      <Box>
        <Content>
          <BackwardBar title="繼續結帳" onNavigate={() => navigate(`/group/${groupId}`)} />
          <Box borderBottomWidth="1px" borderColor="gray.200" py={2}>
            <Heading size="md" textAlign="center">
              揪團訂
            </Heading>
          </Box>
        </Content>
      </Box>
      <Box p={4}>
        <Content>
          <SectionContainer
            title="揪團訂"
            icon={<Icon as={IoPeopleOutline} color="secondary" boxSize="1.5rem" />}
          >
            {isHost ? <HostContent /> : <MemberContent />}
          </SectionContainer>
        </Content>
      </Box>
    </PageContainer>
  );
}
